import AgoraRTC from 'agora-rtc-sdk-ng'
const events = require('events')
let e = null
const defaultOptions = { mode: 'rtc', codec: 'vp8', loglevel: 0 }

console.log('ManageAi Agora Plugin Vue.js 1.0.0')

// Declare variables to create an Agora Engine instance and join a channel
class AgoraVue {
  constructor (options) {
    this.appid = options.appid || ''
    this.token = options.token || ''
    this.mode = options.mode || 'rtc'
    this.codec = options.codec || 'vp8'
    this.events = null
    this.uid = null
    this.channel = null
    this.rtc = {
      localAudioTrack: null,
      localVideoTrack: null,
      screenTrack: null,
      client: null
    }
    this.stateBtn = false

    this.eleUser = options.eleUser || 'user-stream'
    this.eleUserList = options.eleUserList || 'user-stream-list'
    this.eleMuteMic = options.eleMuteMic || 'mic-btn'
    this.eleMuteVideo = options.eleMuteVideo || 'camera-btn'

    this.localTrackState = {
      audioTrackMuted: true,
      videoTrackMuted: true,
      screenTrackMute: true
    }

    this.mainUid = null
    this.myUid = null
    this.logLevel = options.logLevel || 4 // refs https://docs.agora.io/en/Video/API%20Reference/web_ng/interfaces/iagorartc.html#disablelogupload
  }

  async New () {
    // # Set Log Level
    AgoraRTC.setLogLevel(this.logLevel)

    // # Create Event listener
    e = new events.EventEmitter()

    // # Create Agora Client
    this.rtc.client = AgoraRTC.createClient({ mode: this.mode, codec: this.codec })

    // # Callback
    // callback(this)
  }

  /**
   * เป็น Method ที่ใช้ในการ Join Channel Agora
   * @param  {string}   appid Agora App ID
   * @param  {string}   token Agora Token
   * @param  {string}   channel channel ที่จะทำการ Join
   * @param  {int}      uid user id ที่ทำการ join ไปยัง Channel
   * @param  {function}  callback callback function
   * @return {null} null
   */
  async Join (config = { appid: null, token: null, channel: null, uid: null }) {
    try {
      // # initial Variable
      this.uid = config.uid
      this.channel = config.channel
      this.appid = config.appid
      this.token = config.token

      // # Event Listner When "user join channel"
      this.rtc.client.on('user-joined', async (evt) => {
        e.emit('user-joined', evt)
        console.log('AgoraRTC : user-joined')
      })
      // # Event Listner When "user publish audio or video"
      this.rtc.client.on('user-published', async (user, mediaType) => {
        await this.rtc.client.subscribe(user, mediaType)
        e.emit('user-published', user, mediaType)
        console.log('AgoraRTC : user-published : ', mediaType)
      })

      // # Event Listner When "user unpublish audio or video"
      this.rtc.client.on('user-unpublished', async (user, mediaType) => {
        e.emit('user-unpublished', user, mediaType)
        console.log('AgoraRTC : user-unpublished : ', mediaType)
      })

      // # Event Listner When "user leave from channel"
      this.rtc.client.on('user-left', async (user) => {
        e.emit('user-left', user)
        console.log('AgoraRTC : user-left')
      })

      // # Start Join Channel Agora
      await this.rtc.client.join(config.appid, config.channel, config.token, config.uid)

      // # Create a local audio track from the audio sampled by a microphone.
      this.rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack()
      this.localTrackState.audioTrackMuted = false
      // console.log(this.rtc.localAudioTrack)

      // # Create a local video track from the video captured by a camera.
      this.rtc.localVideoTrack = await AgoraRTC.createCameraVideoTrack()
      this.localTrackState.videoTrackMuted = false
      // console.log(this.rtc.localVideoTrack)

      // # Publish data to Channel Agora
      await this.rtc.client.publish([this.rtc.localAudioTrack, this.rtc.localVideoTrack])

      // # Pass the DIV container and the SDK dynamically creates a player in the container for playing the local video track.
      await this.rtc.localVideoTrack.play(`player-${config.uid}`)

      // # Callback
      //   callback(this)
    } catch (error) {
      console.error('Join Error : ', error.message)
    }
  }

  SetMuteMicrophone (status) {
    if (this.rtc.localAudioTrack != null) {
      this.rtc.localAudioTrack.setMuted(status)
      this.localTrackState.audioTrackMuted = status
    }
  }

  SetMuteCamera (status) {
    if (this.rtc.localVideoTrack != null) {
      this.rtc.localVideoTrack.setMuted(status)
      this.localTrackState.videoTrackMuted = status
    }
  }

  async handleScreenShare (val) {
    let res = false
    if (val) {
      res = this.stopScreenShare()// ถ้า val เป็น true แสดงว่า ให้stopScreenShare
    } else {
      res = this.startScreenShare()
    }
    return res
  };

  async startScreenShare () {
    // console.log('else SetMuteScreen')
    // NOTE เมื่อมีการ Shared Screen
    // TODO 1.Create Screen track
    try {
      this.rtc.screenTrack = await AgoraRTC.createScreenVideoTrack({ displaySurface: 'monitor' })
      // กรณีที่มีการ click จอ
    } catch (err) {
      // console.log(err.message)
      if (err.name === 'AgoraRTCException') {
        // console.log('ต้อง emitค่า ไปบอก เปลี่ยน status ที่ส่ง มายัง SetMuteScreen (status)')
        return false
      } else {
        // other errors
        console.log('Error: ' + err.message)
      }
      // if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
      //   // required track is missing
      // } else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
      //   // webcam or mic are already in use
      // } else if (err.name === 'OverconstrainedError' || err.name === 'ConstraintNotSatisfiedError') {
      //   // constraints can not be satisfied by avb. devices
      // } else if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
      //   // permission denied in browser
      //   console.log(' permission denied in browser')
      // } else if (err.name === 'TypeError' || err.name === 'TypeError') {
      //   // empty constraints object
      // } else {
      //   // other errors
      //   console.log('Error: ' + err.name)
      // }
    }
    // TODO 2.Check local video track and unpublish
    if (this.rtc.localVideoTrack != null) {
      await this.rtc.client.unpublish(this.rtc.localVideoTrack)
    }
    this.localTrackState.videoTrackMuted = true

    // TODO 3.Publish screen track
    await this.rtc.client.publish(this.rtc.screenTrack)

    // TODO 4.Display none video player
    let query = `.player-${this.uid} div[id^=agora-video-player-track-cam-]`
    if (document.querySelector(query)) {
      // document.querySelector(query).remove()
      document.querySelector(query).style.display = 'none'
    }
    query = `.player-${this.uid} div[id^=agora-video-player-track-scr]`
    if (document.querySelector(query)) {
      document.querySelector(query).remove()
      // document.querySelector(query).style.display = 'block'
    }

    // TODO 5.PLay Local screen track
    await this.rtc.screenTrack.play(`player-${this.uid}`, () => {
      console.log('PLay Local screen track')
    })

    // TODO 6.set state video track
    this.localTrackState.screenTrackMute = false

    // https://github.com/digitallysavvy/group-video-chat/blob/master/agora-live-video.js
    // Listen for screen share ended event (from browser ui button)
    this.rtc.screenTrack.on('track-ended', () => {
      this.stopScreenShare()
      e.emit('track-ended', false)
    })
    return true
  }

  async stopScreenShare () {
    // console.log('if SetMuteScreen')
    // NOTE เมื่อไม่มีการ Shared Screen

    // TODO 1.Unplublish screen track
    if (this.rtc.screenTrack != null) {
      // console.log('1')
      await this.rtc.client.unpublish(this.rtc.screenTrack)
    } else {
      // console.log('2')
    }
    // TODO 2.ลบ Element ที่เคยเป็น Elemrnt Shared Screen
    let query = `.player-${this.uid} div[id^=agora-video-player-track-scr]`
    if (document.querySelector(query)) {
      // document.querySelector(query).remove()
      document.querySelector(query).style.display = 'none'
    }
    query = `.player-${this.uid} div[id^=agora-video-player-track-cam-]`
    if (document.querySelector(query)) {
      // document.querySelector(query).remove()
      document.querySelector(query).style.display = 'block'
    }

    // TODO 3.Check local video track and publish
    if (this.rtc.localVideoTrack != null) {
      await this.rtc.client.publish(this.rtc.localVideoTrack)

      // TODO 4.Publish screen track
      await this.rtc.localVideoTrack.play(`player-${this.uid}`)
    }

    // TODO 5.set state video track
    this.localTrackState.screenTrackMute = true
    this.rtc.screenTrack.close()// สั่งปิด screen ที่แชร์
  }

  async SetMuteScreen (status) {
    if (status) {
      // NOTE เมื่อไม่มีการ Shared Screen
      // if (this.localTrackState.screenTrackMute) {
      // TODO 1.Unplublish screen track
      if (this.rtc.screenTrack != null) {
        await this.rtc.client.unpublish(this.rtc.screenTrack)
      } else {
        console.log('this.rtc.screenTrack = null')
      }

      // TODO 2.ลบ Element ที่เคยเป็น Elemrnt Shared Screen
      let query = `.player-${this.uid} div[id^=agora-video-player-track-scr]`
      if (document.querySelector(query)) {
        // document.querySelector(query).remove()
        document.querySelector(query).style.display = 'none'
      }
      query = `.player-${this.uid} div[id^=agora-video-player-track-cam-]`
      if (document.querySelector(query)) {
        // document.querySelector(query).remove()
        document.querySelector(query).style.display = 'block'
      }

      // TODO 3.Check local video track and publish
      if (this.rtc.localVideoTrack != null) {
        await this.rtc.client.publish(this.rtc.localVideoTrack)

        // TODO 4.Publish screen track
        await this.rtc.localVideoTrack.play(`player-${this.uid}`)
      }

      // TODO 5.set state video track
      this.localTrackState.screenTrackMute = true
    } else {
      // NOTE เมื่อมีการ Shared Screen
      // if (!this.localTrackState.screenTrackMute) {
      // NOTE https://docs.agora.io/en/video-calling/develop/product-workflow?platform=web
      // TODO 1.Create Screen track
      try {
        this.rtc.screenTrack = await AgoraRTC.createScreenVideoTrack()
        // ตรวจ Check ว่ามีการ click เลือกจอหรือ เลือก cancle
      } catch (err) {
        if (err.name === 'AgoraRTCException') {
          // console.log('ต้อง emitค่า ไปบอก เปลี่ยน status ที่ส่ง มายัง SetMuteScreen (status)')
          return false
        } else {
          // other errors
          console.log('Error: ' + err.message)
        }
      }

      // TODO 2.Check local video track and unpublish
      if (this.rtc.localVideoTrack != null) {
        await this.rtc.client.unpublish(this.rtc.localVideoTrack)
      }
      this.localTrackState.videoTrackMuted = true

      // TODO 3.Publish screen track
      await this.rtc.client.publish(this.rtc.screenTrack)

      // TODO 4.Display none video player
      let query = `.player-${this.uid} div[id^=agora-video-player-track-cam-]`
      if (document.querySelector(query)) {
        // document.querySelector(query).remove()
        document.querySelector(query).style.display = 'none'
      }
      query = `.player-${this.uid} div[id^=agora-video-player-track-scr]`
      if (document.querySelector(query)) {
        document.querySelector(query).remove()
        // document.querySelector(query).style.display = 'block'
      }

      // TODO 5.PLay Local screen track
      await this.rtc.screenTrack.play(`player-${this.uid}`, () => {
        console.log('PLay Local screen track')
      })

      // TODO 6.set state video track
      this.localTrackState.screenTrackMute = false
      return true
    }
  }

  PlayLocalTrack () {
    setTimeout(() => {
      if (!this.localTrackState.videoTrackMuted) {
        if (this.rtc.localVideoTrack != null) {
          this.rtc.localVideoTrack.play(`player-${this.uid}`)
        }
      } else if (!this.localTrackState.screenTrackMute) {
        if (this.rtc.screenTrack != null) {
          this.rtc.screenTrack.play(`player-${this.uid}`)
        }
      }
    }, 150)
  }

  PlayRemoteTrack (users) {
    setTimeout(async () => {
      for (const item of users) {
        if (item.remoteVideoTrack != null) {
          await item.remoteVideoTrack.play(`player-${item.uid}`)
        } else if (item.screenTrack != null) {
          await item.screenTrack.play(`player-${this.uid}`)
        }
      }
    }, 150)
  }

  Leave () {
    // # Destroy the local audio and video tracks.
    if (this.rtc.localAudioTrack != null) this.rtc.localAudioTrack.close()
    if (this.rtc.localVideoTrack != null) this.rtc.localVideoTrack.close()
    if (this.rtc.screenTrack != null) this.rtc.screenTrack.close()
    if (this.rtc.client != null) this.rtc.client.leave()

    // ทำการลบ
    let query = `.player-${this.uid} div[id^=agora-video-player-track-scr]`
    if (document.querySelector(query)) {
      document.querySelector(query).remove()
    }
    query = `.player-${this.uid} div[id^=agora-video-player-track-cam-]`
    if (document.querySelector(query)) {
      document.querySelector(query).remove()
    }

    query = 'div[id=video_track-cam-]'
    if (document.querySelector(query)) {
      document.querySelector(query).remove()
    }
  }

  /**
   * สำหรับ Get Camera Devices
   * @returns Array
   */
  async GetCameras () {
    return await AgoraRTC.getCameras()
  }

  /**
   * สำหรับ Get Microphones Devices
   * @returns Array
   */
  async GetMicrophones () {
    return await AgoraRTC.getMicrophones()
  }

  /**
   * สำหรับ Get Playback Devices
   * @returns Array
   */
  async GetPlaybackDevices () {
    return await AgoraRTC.getPlaybackDevices()
  }

  //   async GetScreenDevices() {
  //     return await AgoraRTC.getElectronScreenSources()
  //   }

  /**
   * สำหรับตรวจสอบ Hardware ว่าสามารถใช้งานได้หรือไม่
   * @return {bool} boolean
   */
  CheckSystemRequirements () {
    return AgoraRTC.checkSystemRequirements()
  }

  /**
   * สำหรับ Get Support Codec
   * @returns Array
   */
  async getSupportedCodec () {
    return await AgoraRTC.getSupportedCodec()
  }

  /**
   * Response Event Listner
   * @returns Events
   */
  Event () {
    return e
  }
}

export default {
  // # called by Vue.use(FirstPlugin)
  install (Vue, options) {
    // # merge default options with arg options
    const userOptions = { ...defaultOptions, ...options }

    // # Connect Agora Server
    Vue.prototype.$Agora = new AgoraVue(userOptions)
  }
}
